import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import constants from '../../core/constants';
import { KeycloakManager } from '@/core/managers/keycloakManager';
import { Creators as logoutActions } from '@/domain/useCases/login/signOutUseCase';

const useSurvey = () => {
  const dispatch = useDispatch();
  const { data, blocked, lastLimitDate } = useSelector(
    (state: any) => state?.survey
  );
  const [showModalSurvey, setShowModalSurvey] = useState(true);

  const { token } = KeycloakManager.getInstance().getToken();

  const getUrlSurveys = (tk: string) => {
    if (typeof tk === 'undefined' || !tk)
      return 'https://encuestas.utp.edu.pe/DefaultUTP.aspx';
    return `${constants.URL_SURVEY}?tkn=${tk}`;
  };

  const hideSurvey = () => setShowModalSurvey(false);

  const closeSession = () => {
    dispatch(logoutActions.signOut());
  };

  const goToSurveys = () => {
    window.open(getUrlSurveys(token), blocked ? '_SELF' : '_BLANK');
  };

  return {
    showModalSurvey,
    hideSurvey,
    surveysData: data,
    blocked,
    lastLimitDate,
    goToSurveys,
    closeSession
  };
};

export default useSurvey;
